import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import InputSearch from "../../../../components/inputs/inputSearch/inputSearch";
import InputDropdown from "../../../../components/inputs/inputDropdown/inputDropdown";

import Table from "../../../../components/table/table";
import Notification from "../../../../components/notification/notification";
import Button from "../../../../components/button/button";
import Modal from "../../../../components/modal/modal";
import Popup from "../../../../components/popup/popup";
import Input from "../../../../components/inputs/input/input";
import InputTextfield from "../../../../components/inputs/inputTextfield/inputTextfield";
import { getApiInstance } from "../../../../utils/api";
import TableEditable from "../../../../components/tableEditable/tableEditable";
import FileList from "../../../../components/fileList/fileList.jsx";
import { formatDateComment } from "../../../../utils/utils";
import { BiExport } from "react-icons/bi";
import { FiFilter } from "react-icons/fi";
import { AiOutlineWarning } from "react-icons/ai";
import Accordion from "../../../../components/accordion/accordion";
import icono1 from "../../../../assets/img/icono1.jpg";
import icono2 from "../../../../assets/img/icono2.jpg";
import Tag from "../../../../components/tag/tag";
import "./gestionEspeciales.scss";

export default function GestionEspeciales({ user }) {
  const api = getApiInstance();
  const notificationRef = useRef();
  const location = useLocation();
  const { hash, pathname, search } = location;

  const [searchTerm, setSearchTerm] = useState("");
  const [especiales, setEspeciales] = useState([]);
  const [loading, setLoading] = useState(false);

  // Proveedores
  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState(null);

  // comentarios por fila (mapa por referencia)
  const [comentariosProveedorMap, setComentariosProveedorMap] = useState({});
  const [comentariosAtlanteMap, setComentariosAtlanteMap] = useState({});
  const [comentariosPorFila, setComentariosPorFila] = useState({});

  // Estado para el modal de comentarios
  const [isComentariosModalOpen, setIsComentariosModalOpen] = useState(false);
  const [comentarioModalRow, setComentarioModalRow] = useState(null);
  const [comentarioModalInput, setComentarioModalInput] = useState("");
  const [comentarioModalFiles, setComentarioModalFiles] = useState([]);
  const [comentarioModalInputFileText, setComentarioModalInputFileText] =
    useState("Selecciona un archivo");
  const [selectedEspeciales, setSelectedEspeciales] = useState([]);

  // Estado para trackear actividades vistas por el usuario (IdDetalle -> objeto con fechas)
  const [actividadesVistas, setActividadesVistas] = useState(() => {
    const codUsuario = user?.codUsuario ?? user?.CodUsuario ?? 'default';
    const stored = localStorage.getItem(`actividadesVistas_${codUsuario}`);
    try {
      return stored ? new Map(Object.entries(JSON.parse(stored))) : new Map();
    } catch {
      return new Map();
    }
  });

  // Estado para el modal de filtros
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filterTienda, setFilterTienda] = useState([]);
  const [filterUnidad, setFilterUnidad] = useState([]);
  const [filterAprobado, setFilterAprobado] = useState([]);
  const [filterTiendasCerradas, setFilterTiendasCerradas] = useState(false);
  const [filterTiendasAbiertas, setFilterTiendasAbiertas] = useState(false);
  const [filterConComentarios, setFilterConComentarios] = useState(false);
  const [tiendasOptions, setTiendasOptions] = useState([]);
  const [selectedTienda, setSelectedTienda] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [deleteIds, setDeleteIds] = useState([]);
  

  const formatNumber = (value) => {
    if (value === null || value === undefined || value === "") return "";
    const n = Number(value);
    if (isNaN(n)) return String(value);
    return n.toLocaleString();
  };

  const fetchEspeciales = async (codTienda = "") => {
    try {
      setLoading(true);

      // Para admin, usar endpoint que muestre especiales de todas las empresas
      const params = new URLSearchParams();
      if (selectedProveedor) {
        // Filtrar por proveedor específico cuando esté seleccionado
        params.append("codEmpresa", selectedProveedor.codEmpresa);
      }

      if(codTienda){
        params.append("codTienda", codTienda);
      }

      params.append("admin", "true"); // Indicar que es vista de admin
      params.append("top", "2000"); // Más elementos para admin

      const url = `/api/GOI/Especiales/Global?${params.toString()}`;
      console.log("Admin fetching especiales from:", url);
      const res = await api.get(url);

      console.log(
        "Admin especiales response:",
        res.status,
        res.data?.length || 0
      );
      if (res && res.status === 200 && Array.isArray(res.data)) {
        setEspeciales(res.data);
      } else {
        setEspeciales([]);
      }
    } catch (err) {
      console.error("Error cargando mobiliario especial:", err);
      setEspeciales([]);
      notificationRef.current?.addNotification(
        "Error cargando mobiliario especial.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // Obtener proveedores (solo codTipoEmpresa === 3)
  const fetchProveedores = async () => {
    try {
      const res = await api.get("/api/Empresa/GetAllEmpresas");
      if (res && res.status === 200 && Array.isArray(res.data)) {
        setProveedores(res.data.filter((x) => x.codTipoEmpresa === 3));
      } else {
        setProveedores([]);
      }
    } catch (err) {
      setProveedores([]);
    }
  };

  const fetchComentarios = async () => {
    const api = getApiInstance();
    try {
      const response = await api.get(
        `/api/Mueble/GetAllComentariosPresupuesto/${comentarioModalRow.idDetalle}`
      );

      if (response.status !== 200) {
        notificationRef.current?.addNotification(
          "Error cargando comentarios.",
          "error"
        );
        return;
      }

      const comentarios = response.data.map((com) => ({
        codComentario: com.codComentario,
        comentario: com.comentario,
        nombreUsuario:
          com.nombreUsuario == user.nombre ? "Tú" : com.nombreUsuario,
        fecha: formatDateComment(com.fecha),
        rutasArchivos: com.rutasArchivos || [],
      }));

      // Actualiza el estado de comentarios por fila

      setComentariosPorFila((prev) => {
        const id = comentarioModalRow.idDetalle;
        const prevList = prev[id] ?? [];

        // Índice por codComentario para mezclar sin duplicar
        const map = new Map(prevList.map((c) => [c.codComentario, c]));

        for (const c of comentarios) {
          // Si ya existe, actualízalo; sino, añádelo
          map.set(c.codComentario, {
            ...(map.get(c.codComentario) ?? {}),
            ...c,
          });
        }

        const merged = Array.from(map.values());

        return {
          ...prev,
          [id]: merged,
        };
      });
    } catch (error) {
      console.error(error);
    }
  };

  const getNombreTiendaNotificacion = (row, selectedTienda) =>
  row?.tiendaNombre ??
  row?.TiendaNombre ??
  row?.nombreTienda ??
  row?.NombreTienda ??
  row?.tiendaCodigo ??
  row?.TiendaCodigo ??
  row?.codigoTienda ??
  row?.CodigoTienda ??
  selectedTienda?.label ??
  selectedTienda?.tienda?.Codigo ??
  selectedTienda?.value ??
  "Tienda no especificada";

  const fetchSendNotification = async (comentario) => {
    try {
      const api = getApiInstance();

      const formData = new FormData();

      // Obtener información detallada del mueble para la notificación
      const referencia =
        comentarioModalRow?.referencia ??
        comentarioModalRow?.Referencia ??
        comentarioModalRow?.CodigoEspecial ??
        comentarioModalRow?.Codigo ??
        "Sin referencia";

      const proveedorNombre =
        selectedProveedor?.nombre ??
        empresaNombres[selectedProveedor?.codEmpresa] ??
        "Proveedor no especificado";

      const tiendaNombre = getNombreTiendaNotificacion(
        comentarioModalRow,
        selectedTienda
      );

      const tiendaCodigo =
        comentarioModalRow?.tiendaCodigo ??
        comentarioModalRow?.TiendaCodigo ??
        comentarioModalRow?.codigoTienda ??
        comentarioModalRow?.CodigoTienda ??
        "";
      const tiendaCiudad =
        comentarioModalRow?.tiendaCiudad ??
        comentarioModalRow?.TiendaCiudad ??
        comentarioModalRow?.ciudad ??
        comentarioModalRow?.Ciudad ??
        "";
      const tiendaPais =
        comentarioModalRow?.tiendaPais ??
        comentarioModalRow?.TiendaPais ??
        comentarioModalRow?.pais ??
        comentarioModalRow?.Pais ??
        "";

      const tiendaLabel = [
        tiendaCodigo ? `[${tiendaCodigo}]` : null,
        tiendaNombre,
        tiendaCiudad || tiendaPais
          ? `(${[tiendaCiudad, tiendaPais].filter(Boolean).join(", ")})`
          : null,
      ]
        .filter(Boolean)
        .join(" ");

      // Crear mensaje claro y bien estructurado para el proveedor
      const mensajeDetallado = `Comentario: "${comentario.comentario}" | Tienda: ${tiendaLabel}`;

      // Tipos destinatarios
      // None = 0,
      // Admin = 1,
      // Todos = 2,
      // Personalizado = 3
      // AdminProveedores = 4

      formData.append("DestinatariosNotificacion", 4);
      formData.append("CodUsuarioNotifica", user.codUsuario); // Usuario que crea la notificación
      formData.append("Mensaje", mensajeDetallado);
      formData.append(
        "Titulo",
        `Nuevo comentario en especiales - ${referencia}`
      );

      // Tipos notificación (sin aplicación en el front por ahora)
      // Info = 0,
      // Warning = 1,
      // Error = 2

      formData.append("TipoNotificacion", 0);

      // Construir URL que apunte a la página correcta de presupuestos con el tab de especiales activo
      // y incluir parámetros para navegación directa al comentario
      const codEmpresaProveedor = selectedProveedor?.codEmpresa ?? "";
      const enlaceConParametros = `/admin/presupuestos?activeTab=mobiliarioEspecial&comentario=${comentarioModalRow?.idDetalle}&codComentario=${comentario.codComentario}&proveedor=${codEmpresaProveedor}`;

      // Usar URL completa con parámetros para navegación directa
      formData.append("Enlace", enlaceConParametros);

      let response = await api.post(`/api/Notificaciones`, formData);
    } catch (error) {
      console.error("Error adding notifications data:", error);
    }
  };

  const fetchTiendas = async () => {
    try {
      const res = await api.get("/api/Presupuestos/tiendas");
      if (res && res.status === 200 && Array.isArray(res.data)) {
        const opts = res.data.map((t) => {
          const codigo = t.Codigo ?? t.codigo ?? "";
          const cadena = t.Cadena ?? t.cadena ?? "";
          const ciudad = t.Ciudad ?? t.ciudad ?? "";
          const pais = t.Pais ?? t.pais ?? "";
          
          let label = `${codigo} - ${cadena}`;
          if (ciudad || pais) {
            const ubicacion = [ciudad, pais].filter(Boolean).join(", ");
            if (ubicacion) {
              label += ` (${ubicacion})`;
            }
          }

          label+= `${t.fechaCierre ? " (C)" : ""}`;
          
          return {
            label: label.trim(),
            value: codigo,
            tienda: {
              ...t,
              CodTienda:
                t.CodTienda ??
                t.codTienda ??
                t.Id ??
                t.id ??
                t.Codigo ??
                t.codigo ??
                "",
            },
          };
        });
        
        // Agregar opción para ver todas las tiendas al inicio
        const opcionTodasTiendas = {
          label: "TODAS LAS TIENDAS",
          value: "TODAS",
          tienda: {
            CodTienda: "TODAS"
          }
        };
        
        setTiendasOptions([opcionTodasTiendas, ...opts]);
      } else {
        const opcionTodasTiendas = {
          label: "TODAS LAS TIENDAS", 
          value: "TODAS",
          tienda: {
            CodTienda: "TODAS"
          }
        };
        setTiendasOptions([opcionTodasTiendas]);
      }
    } catch (err) {
      console.error("Error cargando tiendas (especiales):", err);
      // Incluso en caso de error, proporcionar la opción de todas las tiendas
      const opcionTodasTiendas = {
        label: "TODAS LAS TIENDAS",
        value: "TODAS",
        tienda: {
          CodTienda: "TODAS"
        }
      };
      setTiendasOptions([opcionTodasTiendas]);
    }
  };

  useEffect(() => {
    if (isComentariosModalOpen && comentarioModalRow) {
      fetchComentarios();
    }
  }, [isComentariosModalOpen, comentarioModalRow]);

  useEffect(() => {
    fetchEspeciales();
    fetchProveedores();
    fetchTiendas();
  }, [user]);

  // Recargar especiales cuando cambie el proveedor o la tienda seleccionada
  useEffect(() => {
      // Si se selecciona "TODAS LAS TIENDAS", no pasar codTienda para mostrar todas
      const codTienda = selectedTienda?.tienda?.CodTienda === "TODAS" ? "" : (selectedTienda?.tienda?.CodTienda || "");
      fetchEspeciales(codTienda);
  }, [selectedProveedor, selectedTienda]);
  
  const handleSearch = (query) => {
    setSearchTerm(query);
    setCurrentPage(1); // Resetear a página 1 cuando se haga una nueva búsqueda
  };

  const filtered = useMemo(() => {
    // El backend maneja el filtrado por búsqueda y proveedor
    // Solo devolvemos los datos tal como vienen
    return especiales;
  }, [especiales]);

  const getRowRef = (row) =>
    row?.CodigoEspecial ??
    row?.Codigo ??
    row?.Cod ??
    row?.codigo ??
    row?.Referencia ??
    row?.ReferenciaTarifa ??
    "";

  // inicializar mapas de comentarios cuando cambian los especiales
  useEffect(() => {
    const pMap = {};
    const aMap = {};
    (especiales || []).forEach((r) => {
      const k = getRowRef(r);
      if (!k) return;
      pMap[k] =
        r?.ComentariosProveedor ??
        r?.ComentarioProveedor ??
        r?.ComentarioProv ??
        r?.Comentarios ??
        "";
      aMap[k] =
        r?.ComentariosAtlante ?? r?.ComentarioAtlante ?? r?.ComentarioAtl ?? "";
    });
    setComentariosProveedorMap(pMap);
    setComentariosAtlanteMap(aMap);
  }, [especiales]);

  const handleChangeComentarioProveedor = (ref, value) => {
    setComentariosProveedorMap((prev) => ({ ...prev, [ref]: value }));
  };

  const handleChangeComentarioAtlante = (ref, value) => {
    setComentariosAtlanteMap((prev) => ({ ...prev, [ref]: value }));
  };

  // Mapa de codEmpresa a nombre de proveedor
  const empresaNombres = {
    1: "Grupo Atlante",
    2: "Bershka Imagen",
    3: "Bershka Obras",
    4: "Castel",
    5: "Culdesac",
    6: "Dimalnox",
    7: "Kimak",
    8: "Malasa Mexico",
    9: "Malasa",
    87: "TestEmpresa",
  };

  // Obtener nombre del proveedor según codEmpresa del usuario logeado
  const codEmpresa =
    user?.codEmpresa ??
    user?.CodEmpresa ??
    user?.empresa ??
    user?.Empresa ??
    "";
  const nombreProveedor = empresaNombres[codEmpresa] || "Proveedor";

  // Acción para aprobar un mueble especial usando el endpoint real
  const reloadProveedorEspeciales = async () => {
    if (selectedProveedor) {
      try {
        setLoading(true);
        const res = await api.get(
          `/api/GOI/Proveedores/${selectedProveedor.codEmpresa}/Especiales/Detalles`
        );
        if (res && res.status === 200 && Array.isArray(res.data)) {
          setEspeciales(res.data);
        } else {
          setEspeciales([]);
        }
      } catch (err) {
        setEspeciales([]);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleAprobar = async (row) => {
    try {
      const idDetalle = row.idDetalle;
      if (idDetalle === undefined || idDetalle === null) {
        notificationRef.current?.addNotification(
          "No se ha encontrado el idDetalle.",
          "error"
        );
        return;
      }
      const body = {
        Aprobar: true,
        PrecioEspecial: row.precioEspecial,
        Unidad: row.unidad,
        Divisa: row.divisa,
        Descripcion: row.descripcion,
      };
      const res = await api.put(
        `/api/GOI/Especiales/Detalles/${idDetalle}/Aprobar`,
        body
      );
      if (res && res.status === 200) {
        notificationRef.current?.addNotification(
          `Mueble con referencia ${
            row.referencia ?? row.Referencia ?? "-"
          } aprobado correctamente.`,
          "success"
        );
        await reloadProveedorEspeciales();
      } else {
        notificationRef.current?.addNotification(
          "No se pudo aprobar el mueble.",
          "error"
        );
      }
    } catch (err) {
      notificationRef.current?.addNotification(
        "Error al aprobar el mueble.",
        "error"
      );
    }
  };

  // Acción para desaprobar un mueble especial
  const handleDesaprobar = async (row) => {
    try {
      const idDetalle = row.idDetalle;
      if (idDetalle === undefined || idDetalle === null) {
        notificationRef.current?.addNotification(
          "No se ha encontrado el idDetalle.",
          "error"
        );
        return;
      }
      const body = { DesactivarEnTienda: true };
      const res = await api.put(
        `/api/GOI/Especiales/Detalles/${idDetalle}/Revertir`,
        body
      );
      if (res && res.status === 200) {
        notificationRef.current?.addNotification(
          `Mueble con referencia ${
            row.referencia ?? row.Referencia ?? "-"
          } desaprobado correctamente.`,
          "success"
        );
        await reloadProveedorEspeciales();
      } else {
        notificationRef.current?.addNotification(
          "No se pudo desaprobar el mueble.",
          "error"
        );
      }
    } catch (err) {
      notificationRef.current?.addNotification(
        "Error al desaprobar el mueble.",
        "error"
      );
    }
  };

  // Para edición inline de comentarios proveedor
  const handleEditComentarioProveedor = (row, value) => {
    const ref = getRowRef(row);
    setComentariosProveedorMap((prev) => ({
      ...prev,
      [ref]: value,
    }));
    // Si quieres guardar en backend, aquí puedes hacer un api.post/put
  };

  // Para edición inline de comentarios Atlante
  const handleEditComentarioAtlante = (row, value) => {
    const ref = getRowRef(row);
    setComentariosAtlanteMap((prev) => ({
      ...prev,
      [ref]: value,
    }));
    // Si quieres guardar en backend, aquí puedes hacer un api.post/put
  };

  // Parsear comentarios por proveedor y Atlante desde observaciones
  const parseObservaciones = (observaciones) => {
    if (!observaciones) return [];
    return observaciones.split("|").map((c) => c.trim());
  };

  // Cuando se abre el modal, inicializa el input y archivos
  const handleOpenComentariosModal = (row) => {
    setComentarioModalRow(row);
    setComentarioModalInput("");
    setComentarioModalFiles([]);
    setComentariosPorFila((prev) => ({
        ...prev,
        [row.idDetalle]: getComentariosFromObservaciones(row),
      }));
    
    // Marcar los comentarios como vistos cuando se abre el modal
    const idDetalle = row?.idDetalle ?? row?.IdDetalle;
    if (idDetalle) {
      const fechaActual = new Date().toISOString();
      setActividadesVistas(prev => {
        const newMap = new Map(prev);
        const actividadesPrevias = newMap.get(String(idDetalle)) || {};
        const nuevasActividades = {
          ...actividadesPrevias,
          ultimoComentarioVisto: fechaActual
        };
        newMap.set(String(idDetalle), nuevasActividades);
        // Guardar en localStorage
        const codUsuario = user?.codUsuario ?? user?.CodUsuario ?? 'default';
        localStorage.setItem(`actividadesVistas_${codUsuario}`, JSON.stringify(Object.fromEntries(newMap)));
        return newMap;
      });
    }
    
    setIsComentariosModalOpen(true);
  };

  const handleCloseComentariosModal = () => {
    setIsComentariosModalOpen(false);
    setComentarioModalRow(null);
    setComentarioModalInput("");
    setComentarioModalFiles([]);
  };

  // Función para marcar aprobación como vista
  const marcarAprobacionComoVista = (row) => {
    const idDetalle = row?.idDetalle ?? row?.IdDetalle;
    if (idDetalle) {
      const fechaActual = new Date().toISOString();
      setActividadesVistas(prev => {
        const newMap = new Map(prev);
        const actividadesPrevias = newMap.get(String(idDetalle)) || {};
        const nuevasActividades = {
          ...actividadesPrevias,
          aprobacionVista: fechaActual
        };
        newMap.set(String(idDetalle), nuevasActividades);
        // Guardar en localStorage
        const codUsuario = user?.codUsuario ?? user?.CodUsuario ?? 'default';
        localStorage.setItem(`actividadesVistas_${codUsuario}`, JSON.stringify(Object.fromEntries(newMap)));
        return newMap;
      });
    }
  };

  // Función para marcar importación como vista
  const marcarImportacionComoVista = (row) => {
    const idDetalle = row?.idDetalle ?? row?.IdDetalle;
    if (idDetalle) {
      const fechaActual = new Date().toISOString();
      setActividadesVistas(prev => {
        const newMap = new Map(prev);
        const actividadesPrevias = newMap.get(String(idDetalle)) || {};
        const nuevasActividades = {
          ...actividadesPrevias,
          importacionVista: fechaActual
        };
        newMap.set(String(idDetalle), nuevasActividades);
        // Guardar en localStorage
        const codUsuario = user?.codUsuario ?? user?.CodUsuario ?? 'default';
        localStorage.setItem(`actividadesVistas_${codUsuario}`, JSON.stringify(Object.fromEntries(newMap)));
        return newMap;
      });
    }
  };

  // Manejar archivos en el modal
  const handleComentarioModalFiles = (event) => {
    const filesArray = Array.from(event.target.files);
    setComentarioModalFiles((prevFiles) => [
      ...prevFiles,
      ...filesArray.filter(
        (file) => !prevFiles.some((prevFile) => prevFile.name === file.name)
      ),
    ]);
  };

  // Manejar pegar imágenes desde el portapapeles
  const handlePasteImage = (event) => {
    const items = event.clipboardData?.items;
    if (!items) return;

    const imageFiles = [];
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.type.indexOf('image') !== -1) {
        const file = item.getAsFile();
        if (file) {
          // Generar un nombre único para la imagen pegada
          const timestamp = new Date().getTime();
          const extension = file.type.split('/')[1] || 'png';
          const fileName = `imagen_pegada_${timestamp}.${extension}`;
          
          // Crear un nuevo archivo con el nombre personalizado
          const renamedFile = new File([file], fileName, { type: file.type });
          imageFiles.push(renamedFile);
        }
      }
    }

    if (imageFiles.length > 0) {
      setComentarioModalFiles((prevFiles) => [
        ...prevFiles,
        ...imageFiles.filter(
          (file) => !prevFiles.some((prevFile) => prevFile.name === file.name)
        ),
      ]);
      
      // Mostrar notificación de éxito
      notificationRef.current?.addNotification(
        `${imageFiles.length} imagen${imageFiles.length > 1 ? 'es' : ''} pegada${imageFiles.length > 1 ? 's' : ''} desde el portapapeles.`,
        "success"
      );
    }
  };

  useEffect(() => {
    if (comentarioModalFiles.length === 0) {
      setComentarioModalInputFileText("Selecciona un archivo");
    } else {
      setComentarioModalInputFileText(
        `${comentarioModalFiles.length} ${
          comentarioModalFiles.length > 1
            ? "archivos seleccionados"
            : "archivo seleccionado"
        }`
      );
    }
  }, [comentarioModalFiles]);

  // Simulación de envío de comentario (puedes adaptar para llamar a tu API)
  const handleEnviarComentarioModal = async () => {
    if (!comentarioModalInput.trim() || !comentarioModalRow) return;
    try {
      const fecha = new Date();
      const formData = new FormData();

      formData.append("CodEspecial", comentarioModalRow.idDetalle);
      formData.append("Comentario", comentarioModalInput);
      formData.append("Fecha", fecha.toLocaleString());
      comentarioModalFiles.forEach((file) => {
        formData.append("RutasArchivos", file);
      });

      // Usa el endpoint de detalleMueble
      const response = await api.post(
        `/api/Mueble/ComentarioPresupuesto`,
        formData
      );

      if (response.status === 200) {
        notificationRef.current?.addNotification(
          "Comentario creado correctamente.",
          "success"
        );

        const nuevoComentario = {
          codComentario: response.data.codComentario,
          comentario: comentarioModalInput,
          nombreUsuario: "Tú",
          fecha: formatDateComment(fecha.toISOString()),
          rutasArchivos: comentarioModalFiles,
        };

        setComentariosPorFila((prev) => ({
          ...prev,
          [comentarioModalRow.idDetalle]: [
            ...(prev[comentarioModalRow.idDetalle] || []),
            nuevoComentario,
          ],
        }));
        setComentarioModalInput("");
        setComentarioModalFiles([]);

        // Enviar notificación
        await fetchSendNotification(nuevoComentario);
      } else {
        notificationRef.current?.addNotification(
          "Hubo un error al guardar el comentario.",
          "error"
        );
      }
    } catch (error) {
      notificationRef.current?.addNotification(
        "Hubo un error al guardar el comentario.",
        "error"
      );
    }
  };

  // Simulación de comentarios históricos a partir de observaciones
  const getComentariosFromObservaciones = (row) => {
    if (!row?.observaciones) return [];
    // Divide por "|", luego intenta extraer autor y fecha si están entre corchetes
    return row.observaciones.split("|").map((raw, idx) => {
      const trimmed = raw.trim();
      // Busca patrón tipo: [COMENTARIOS ATLANTE 03/10]: Ok
      const match = trimmed.match(/^\[(.*?)\]:\s*(.*)$/);
      if (match) {
        const autorYFecha = match[1]; // Ej: "COMENTARIOS ATLANTE 03/10"
        const comentario = match[2];
        // Intenta separar autor y fecha si hay fecha
        const autorFechaMatch = autorYFecha.match(/^(.*?)(\d{2}\/\d{2})?$/);
        let nombreUsuario = autorYFecha;
        let fecha = null;
        if (autorFechaMatch) {
          nombreUsuario = autorFechaMatch[1]
            .replace(/COMENTARIOS\s*/i, "")
            .trim();
          fecha = autorFechaMatch[2] || null;
        }
        return {
          codComentario: idx,
          comentario: comentario.trim(),
          nombreUsuario: nombreUsuario || "Desconocido",
          fecha,
          rutasArchivos: [],
        };
      }
      // Si no hay patrón, muestra como comentario genérico
      return {
        codComentario: idx,
        comentario: trimmed,
        nombreUsuario: "Desconocido",
        fecha: null,
        rutasArchivos: [],
      };
    });
  };

  // Función para determinar el tipo de actividad reciente de un mueble
  const getActividadReciente = (row) => {
    const ahora = new Date();
    
    // 0. Verificar primero si hay actividad general reciente (FechaUltimaModificacion)
    const fechaModificacion = row?.fechaUltimaModificacion || row?.FechaUltimaModificacion;
    if (fechaModificacion) {
      try {
        const dateModificacion = new Date(fechaModificacion);
        if (!isNaN(dateModificacion.getTime())) {
          const diasDiferencia = (ahora - dateModificacion) / (1000 * 60 * 60 * 24);
          
          // Si la última modificación es muy antigua (más de 2 días), no mostrar warning
          if (diasDiferencia > 2) {
            return null; // Sin actividad reciente
          }
        }
      } catch {
        // Si falla el parsing, continúar con la lógica normal
      }
    }
    
    // 1. Verificar actividad reciente comparando fechas específicas
    const fechaComentario = row?.fechaUltimoComentario || row?.FechaUltimoComentario;
    const fechaAprobacion = row?.fechaUltimaAprobacion || row?.FechaUltimaAprobacion;
    
    let ultimaAccion = null;
    let fechaUltimaAccion = null;
    
    // Determinar cuál fue la última acción comparando fechas
    if (fechaComentario && fechaAprobacion) {
      const dateComentario = new Date(fechaComentario);
      const dateAprobacion = new Date(fechaAprobacion);
      
      if (dateComentario > dateAprobacion) {
        ultimaAccion = 'comentario';
        fechaUltimaAccion = dateComentario;
      } else {
        ultimaAccion = 'aprobacion';
        fechaUltimaAccion = dateAprobacion;
      }
    } else if (fechaComentario) {
      ultimaAccion = 'comentario';
      fechaUltimaAccion = new Date(fechaComentario);
    } else if (fechaAprobacion) {
      ultimaAccion = 'aprobacion';
      fechaUltimaAccion = new Date(fechaAprobacion);
    }
    
    // Verificar si la última acción fue reciente (últimos 2 días)
    if (ultimaAccion && fechaUltimaAccion && !isNaN(fechaUltimaAccion.getTime())) {
      const diasDiferencia = (ahora - fechaUltimaAccion) / (1000 * 60 * 60 * 24);
      
      if (diasDiferencia <= 2) {
        if (ultimaAccion === 'comentario') {
          const idDetalle = row?.idDetalle ?? row?.IdDetalle;
          
          // Verificar si hay comentarios más recientes que la última vez que los vio el usuario
          const actividadesDelMueble = actividadesVistas.get(String(idDetalle)) || {};
          const fechaUltimoComentarioVisto = actividadesDelMueble.ultimoComentarioVisto;
          if (fechaUltimoComentarioVisto && new Date(fechaComentario) <= new Date(fechaUltimoComentarioVisto)) {
            return null;
          }
          
          const horasDiferencia = Math.floor((ahora - fechaUltimaAccion) / (1000 * 60 * 60));
          if (horasDiferencia < 1) {
            return { tipo: 'comentario', mensaje: 'Nuevo comentario' };
          } else if (horasDiferencia < 24) {
            return { tipo: 'comentario', mensaje: `Comentario hace ${horasDiferencia}h` };
          } else {
            return { tipo: 'comentario', mensaje: `Comentario hace ${Math.floor(diasDiferencia)} día${Math.floor(diasDiferencia) !== 1 ? 's' : ''}` };
          }
        } else if (ultimaAccion === 'aprobacion') {
          const idDetalle = row?.idDetalle ?? row?.IdDetalle;
          
          // Verificar si el usuario ya vio esta aprobación
          const actividadesDelMueble = actividadesVistas.get(String(idDetalle)) || {};
          const fechaAprobacionVista = actividadesDelMueble.aprobacionVista;
          if (fechaAprobacionVista && new Date(fechaAprobacion) <= new Date(fechaAprobacionVista)) {
            return null;
          }
          
          const horasDiferencia = Math.floor((ahora - fechaUltimaAccion) / (1000 * 60 * 60));
          const aprobado = row?.aprobadoEspecial ?? row?.AprobadoEspecial;
          const accion = aprobado ? 'Aprobado' : 'Desaprobado';
          
          if (horasDiferencia < 1) {
            return { tipo: 'aprobacion', mensaje: `${accion} recientemente` };
          } else if (horasDiferencia < 24) {
            return { tipo: 'aprobacion', mensaje: `${accion} hace ${horasDiferencia}h` };
          } else {
            return { tipo: 'aprobacion', mensaje: `${accion} hace ${Math.floor(diasDiferencia)} día${Math.floor(diasDiferencia) !== 1 ? 's' : ''}` };
          }
        }
      }
    }
    
    // 2. Si no hay fechas específicas pero FechaUltimaModificacion es reciente,
    // verificar si es nuevo por IdImportacion
    if (fechaModificacion) {
      try {
        const dateModificacion = new Date(fechaModificacion);
        const diasDiferencia = (ahora - dateModificacion) / (1000 * 60 * 60 * 24);
        
        if (diasDiferencia <= 2 && esNuevoPorImportacion(row)) {
          const idDetalle = row?.idDetalle ?? row?.IdDetalle;
          
          // Verificar si el usuario ya vio este mueble como nuevo
          const actividadesDelMueble = actividadesVistas.get(String(idDetalle)) || {};
          const fechaImportacionVista = actividadesDelMueble.importacionVista;
          if (fechaImportacionVista && new Date(fechaModificacion) <= new Date(fechaImportacionVista)) {
            return null;
          }
          
          return { tipo: 'nuevo', mensaje: 'Mueble recién importado' };
        }
      } catch {
        // Continuar con las verificaciones de fallback
      }
    }
    
    // 3. Verificar actividad reciente por comentarios del modal (fallback)
    const comentarios = comentariosPorFila[row?.idDetalle ?? row?.IdDetalle] || [];
    if (comentarios.length > 0) {
      const idDetalle = row?.idDetalle ?? row?.IdDetalle;
      
      // Verificar si hay comentarios más recientes que la última vez que los vio el usuario
      const actividadesDelMueble = actividadesVistas.get(String(idDetalle)) || {};
      const fechaUltimoComentarioVisto = actividadesDelMueble.ultimoComentarioVisto;
      if (fechaUltimoComentarioVisto) {
        // Si hay fecha de última visualización, verificar si hay comentarios más recientes
        const hayComentariosNuevos = comentarios.some(com => {
          if (!com.fecha) return false;
          try {
            const fechaComentario = new Date(com.fecha);
            return fechaComentario > new Date(fechaUltimoComentarioVisto);
          } catch {
            return false;
          }
        });
        
        if (!hayComentariosNuevos) {
          return null;
        }
      }
      
      const comentariosRecientes = comentarios.filter(com => {
        if (!com.fecha) return false;
        
        try {
          let fechaComentario;
          if (typeof com.fecha === 'string') {
            if (com.fecha.includes('hace')) return true;
            fechaComentario = new Date(com.fecha);
          } else {
            fechaComentario = new Date(com.fecha);
          }
          
          if (isNaN(fechaComentario.getTime())) return false;
          
          const diasDiferencia = (ahora - fechaComentario) / (1000 * 60 * 60 * 24);
          return diasDiferencia <= 2;
        } catch {
          return false;
        }
      });
      
      if (comentariosRecientes.length > 0) {
        return { tipo: 'comentario', mensaje: 'Mueble con comentarios recientes' };
      }
    }
    
    return null; // Sin actividad reciente
  };

  // Función auxiliar para verificar si es nuevo por importación
  const esNuevoPorImportacion = (row) => {
    if (row?.idImportacion !== undefined || row?.IdImportacion !== undefined) {
      const idImportacion = row.idImportacion ?? row.IdImportacion;
      const maxIdImportacion = Math.max(
        ...especiales.map(e => e.idImportacion ?? e.IdImportacion ?? 0)
      );
      return maxIdImportacion === idImportacion;
    }
    return false;
  };

  // Función auxiliar para verificar si es nuevo por IdDetalle
  const esNuevoPorIdDetalle = (row) => {
    if (row?.idDetalle !== undefined || row?.IdDetalle !== undefined) {
      const idDetalle = row.idDetalle ?? row.IdDetalle;
      const maxIdDetalle = Math.max(
        ...especiales.map(e => e.idDetalle ?? e.IdDetalle ?? 0)
      );
      const umbralNuevo = maxIdDetalle - 50;
      return idDetalle > umbralNuevo;
    }
    return false;
  };

  // Función para mantener compatibilidad (usa la nueva lógica)
  const esMuebleNuevo = (row) => {
    const actividad = getActividadReciente(row);
    return actividad !== null;
  };

  // Obtener tipo de empresa del usuario
  const codTipoEmpresa =
    user?.codTipoEmpresa ??
    user?.CodTipoEmpresa ??
    user?.tipoEmpresa ??
    user?.TipoEmpresa ??
    "";

  const columns = [
    {
      key: "nuevo",
      label: "",
      render: (row) => {
        const actividad = getActividadReciente(row);
        if (actividad) {
          const { mensaje, tipo } = actividad;
          
          const handleWarningClick = () => {
            if (tipo === 'aprobacion') {
              marcarAprobacionComoVista(row);
            } else if (tipo === 'nuevo') {
              marcarImportacionComoVista(row);
            }
            // Los comentarios se marcan como vistos cuando se abre el modal, no aquí
          };
          
          // Renderizar imagen personalizada para muebles nuevos, icono para otros tipos
          if (tipo === 'nuevo') {
            return (
              <div 
                style={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  fontSize: '18px',
                  cursor: 'pointer'
                }}
                title={mensaje}
                onClick={handleWarningClick}
              >
                <img 
                  src={icono1} 
                  alt="Mueble recién importado"
                  style={{ 
                    width: '20px', 
                    height: '20px',
                    objectFit: 'contain'
                  }}
                />
              </div>
            );
          } else if (tipo === 'aprobacion') {
            return (
              <div 
                style={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  fontSize: '18px',
                  cursor: 'pointer'
                }}
                title={mensaje}
                onClick={handleWarningClick}
              >
                <img 
                  src={icono2} 
                  alt="Estado de aprobación actualizado"
                  style={{ 
                    width: '20px', 
                    height: '20px',
                    objectFit: 'contain'
                  }}
                />
              </div>
            );
          } else {
            return (
              <div 
                style={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  color: '#ff9800',
                  fontSize: '18px',
                  cursor: 'default'
                }}
                title={mensaje}
              >
                <AiOutlineWarning />
              </div>
            );
          }
        }
        return null;
      },
      editable: false,
      width: 50,
    },
    {
      key: "referencia",
      label: "Referencia",
      render: (row) =>
        row?.referencia ??
        row?.Referencia ??
        row?.CodigoEspecial ??
        row?.Codigo ??
        row?.Cod ??
        row?.codigo ??
        row?.ReferenciaTarifa ??
        "-",
      editable: false,
    },
    {
      key: "codigoTienda",
      label: "Código Tienda",
      render: (row) => {
        const nombre =
          row?.tiendaCodigo ??
          row?.TiendaCodigo ??
          row?.codigoTienda ??
          row?.CodigoTienda ??
          "-";
        const cerrada = row?.tiendaCerrada ?? false;

        return (
          <span
            style={{
              color: cerrada ? "red" : "inherit",
              fontWeight: cerrada ? "bold" : "normal",
            }}
          >
            {nombre}
            {cerrada && " (Cerrada)"}
          </span>
        );
      },
      editable: false,
    },
    {
      key: "nombreTienda",
      label: "Nombre Tienda",
      render: (row) =>
        row?.tiendaNombre ??
        row?.TiendaNombre ??
        row?.nombreTienda ??
        row?.NombreTienda ??
        "-",
      editable: false,
    },
    {
      key: "tiendaPais",
      label: "País",
      render: (row) =>
        row?.tiendaPais ?? row?.TiendaPais ?? row?.pais ?? row?.Pais ?? "-",
      editable: false,
    },
    {
      key: "tiendaCiudad",
      label: "Ciudad",
      render: (row) =>
        row?.tiendaCiudad ??
        row?.TiendaCiudad ??
        row?.ciudad ??
        row?.Ciudad ??
        "-",
      editable: false,
    },
    {
      key: "descripcion",
      label: "Descripcion",
      render: (row) =>
        row?.descripcion ??
        row?.Descripcion ??
        row?.DescripcionArticulo ??
        row?.DescripcionTarifa ??
        row?.descrip ??
        row?.DescripcionImportacion ??
        "-",
      editable: false,
    },
    {
      key: "precio",
      label: "Precio",
      render: (row) =>
        formatNumber(
          row?.precioGOI ??
            row?.PrecioGOI ??
            row?.precioEspecial ??
            row?.PrecioEspecial ??
            row?.Precio ??
            row?.precio ??
            0
        ),
      editable: false,
    },
    {
      key: "unidad",
      label: "Unidad",
      render: (row) =>
        row?.unidad ??
        row?.Unidad ??
        row?.Unidades ??
        row?.UM ??
        row?.um ??
        row?.UnidadImportacion ??
        "-",
      editable: false,
    },
    {
      key: "aprobadoEspecial",
      label: "Aprobado",
      render: (row) =>
        row?.aprobadoEspecial !== undefined
          ? row.aprobadoEspecial
            ? "Sí"
            : "No"
          : row?.AprobadoEspecial
          ? "Sí"
          : "No",
      editable: false,
    },
    {
      key: "verComentarios",
      label: "Comentarios",
      render: (row) => (
        <Button
          label="Ver comentarios"
          variant="outlined"
          onClick={() => handleOpenComentariosModal(row)}
        />
      ),
      editable: false,
    },
    // Solo muestra la columna de acciones si el usuario NO es proveedor
    ...(codTipoEmpresa === 3
      ? []
      : [
          {
            key: "acciones",
            label: "Acciones",
            render: (row) =>
              row.aprobadoEspecial ? (
                <Button
                  label="Desaprobar"
                  variant="danger"
                  onClick={() => handleDesaprobar(row)}
                />
              ) : (
                <Button
                  label="Aprobar"
                  variant="filled"
                  onClick={() => handleAprobar(row)}
                />
              ),
            editable: false,
          },
        ]),
  ];

  const handleExportExcel = async () => {
    try {
      if (selectedEspeciales.length === 0) {
        notificationRef.current.addNotification(
          "No hay solicitudes seleccionadas para exportar.",
          "warning"
        );
        return;
      }

      console.log("Exportando especiales seleccionados:", {
        selectedEspeciales,
        cantidad: selectedEspeciales.length,
      });

      const api = getApiInstance();
      const response = await api.post(
        `/api/GOI/Especiales/ExportarSeleccionados`,
        selectedEspeciales,
        { responseType: "blob" }
      );

      if (response.status !== 200) {
        throw new Error("Error al descargar el archivo");
      }

      const blob = await response.data;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;

      let fileName = "Especiales_GOI.xlsx";
      const disposition = response.headers.get("Content-Disposition");
      if (disposition && disposition.indexOf("filename=") !== -1) {
        const fileNameMatch = disposition.match(/filename="?([^"]+)"?/);
        if (fileNameMatch && fileNameMatch.length > 1) {
          fileName = fileNameMatch[1];
        }
      }
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      notificationRef.current.addNotification(
        "Archivo descargado correctamente.",
        "success"
      );
    } catch (error) {
      notificationRef.current.addNotification(
        "Error al descargar el archivo.",
        "error"
      );
      console.error("Error al descargar el archivo:", error);
    }
  };

  const handleDeleteSelectedEspeciales = async () => {
    if (selectedEspeciales.length === 0) {
      notificationRef.current?.addNotification(
        "Selecciona al menos un mueble para eliminar.",
        "warning"
      );
      return;
    }

    const ids = selectedEspeciales
      .map((item) => {
        if (item && typeof item === "object") {
          return item?.idDetalle ?? item?.IdDetalle;
        }
        return item;
      })
      .filter((id) => Number.isFinite(Number(id)) && Number(id) > 0);

    if (ids.length === 0) {
      notificationRef.current?.addNotification(
        "No se encontraron identificadores válidos para eliminar.",
        "error"
      );
      return;
    }

    setDeleteIds(ids);
    setIsDeleteConfirmOpen(true);
  };

  const confirmDeleteSelectedEspeciales = async () => {
    if (deleteIds.length === 0) {
      setIsDeleteConfirmOpen(false);
      return;
    }

    try {
      setLoading(true);

      const deleteQuery = codTipoEmpresa === 3 ? "" : "?admin=true";

      const resultados = await Promise.allSettled(
        deleteIds.map((idDetalle) =>
          api.delete(`/api/GOI/Especiales/${idDetalle}${deleteQuery}`)
        )
      );

      const eliminados = resultados.filter((r) => r.status === "fulfilled").length;
      const fallidos = resultados.length - eliminados;

      if (eliminados > 0) {
        notificationRef.current?.addNotification(
          `${eliminados} mueble${eliminados > 1 ? "s" : ""} eliminado${
            eliminados > 1 ? "s" : ""
          } correctamente.`,
          "success"
        );
      }

      if (fallidos > 0) {
        notificationRef.current?.addNotification(
          `No se pudieron eliminar ${fallidos} mueble${
            fallidos > 1 ? "s" : ""
          }.`,
          "warning"
        );
      }

      setSelectedEspeciales([]);
      setDeleteIds([]);
      setIsDeleteConfirmOpen(false);
      const codTienda =
        selectedTienda?.tienda?.CodTienda === "TODAS"
          ? ""
          : selectedTienda?.tienda?.CodTienda || "";
      await fetchEspeciales(codTienda);
    } catch (error) {
      notificationRef.current?.addNotification(
        "Error al eliminar los muebles seleccionados.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const tiendas = useMemo(() => {
    return especiales
      .map((e) => e.tiendaNombre ?? e.TiendaNombre)
      .filter((v, i, arr) => v && arr.indexOf(v) === i);
  }, [especiales]);
  const unidades = useMemo(() => {
    return especiales
      .map((e) => e.unidad)
      .filter((v, i, arr) => v && arr.indexOf(v) === i);
  }, [especiales]);
  const aprobados = ["Aprobado", "No aprobado"];

  const filteredEspeciales = useMemo(() => {
    // La búsqueda y los filtros se aplican localmente en cliente
    let filtered = especiales;

    // Búsqueda local por términos: "aco lingote" encuentra "ACO ESTANDAR ... LINGOTE"
    if (searchTerm.trim()) {
      const normalize = (value) =>
        String(value ?? "")
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();

      const terms = normalize(searchTerm).split(/\s+/).filter(Boolean);

      filtered = filtered.filter((item) => {
        const searchableText = normalize(
          [
            item?.referencia,
            item?.Referencia,
            item?.CodigoEspecial,
            item?.Codigo,
            item?.Cod,
            item?.codigo,
            item?.ReferenciaTarifa,
            item?.descripcion,
            item?.Descripcion,
            item?.DescripcionArticulo,
            item?.DescripcionTarifa,
            item?.descrip,
            item?.DescripcionImportacion,
            item?.tiendaNombre,
            item?.TiendaNombre,
            item?.nombreTienda,
            item?.NombreTienda,
            item?.tiendaCodigo,
            item?.TiendaCodigo,
            item?.codigoTienda,
            item?.CodigoTienda,
            item?.tiendaCiudad,
            item?.TiendaCiudad,
            item?.ciudad,
            item?.Ciudad,
            item?.tiendaPais,
            item?.TiendaPais,
            item?.pais,
            item?.Pais,
            item?.unidad,
            item?.Unidad,
            item?.Unidades,
            item?.UM,
            item?.um,
            item?.UnidadImportacion,
          ].join(" ")
        );

        return terms.every((term) => searchableText.includes(term));
      });
    }

    if (filterTienda.length > 0) {
      filtered = filtered.filter((e) =>
        filterTienda.includes(e.tiendaNombre ?? e.TiendaNombre)
      );
    }
    if (filterUnidad.length > 0) {
      filtered = filtered.filter((e) => filterUnidad.includes(e.unidad));
    }

    if (filterTiendasCerradas) {
      filtered = filtered.filter((item) => {
        return item.tiendaCerrada;
      });
    }

    if (filterTiendasAbiertas) {
      filtered = filtered.filter((item) => {
        return !item.tiendaCerrada;
      });
    }

    if (filterAprobado.length > 0) {
      filtered = filtered.filter((e) => {
        const aprobado = e.aprobadoEspecial ?? e.AprobadoEspecial;
        if (filterAprobado.includes("Aprobado")) return aprobado === true;
        if (filterAprobado.includes("No aprobado")) return aprobado === false;
        return true;
      });
    }

    // Filtrar por muebles con comentarios
    if (filterConComentarios) {
      filtered = filtered.filter((e) => {
        const idDetalle = e.idDetalle ?? e.IdDetalle;
        const ref = e?.CodigoEspecial ??
          e?.Codigo ??
          e?.Cod ??
          e?.codigo ??
          e?.Referencia ??
          e?.ReferenciaTarifa ??
          "";

        // Verificar si tiene comentarios en el modal
        const tieneComentariosModal = comentariosPorFila[idDetalle] && 
          comentariosPorFila[idDetalle].length > 0;

        // Verificar si tiene comentarios de proveedor
        const tieneComentariosProveedor = comentariosProveedorMap[ref] && 
          comentariosProveedorMap[ref].trim() !== "";

        // Verificar si tiene comentarios de Atlante  
        const tieneComentariosAtlante = comentariosAtlanteMap[ref] &&
          comentariosAtlanteMap[ref].trim() !== "";

        // Verificar si tiene observaciones con comentarios
        const tieneObservaciones = e.observaciones && 
          e.observaciones.trim() !== "";

        return tieneComentariosModal || tieneComentariosProveedor || 
               tieneComentariosAtlante || tieneObservaciones;
      });
    }

    return [...filtered].sort((a, b) => {
  // Primer criterio: estado de aprobación (pendientes primero)
  const aAprobado = a.aprobadoEspecial ?? a.AprobadoEspecial ?? false;
  const bAprobado = b.aprobadoEspecial ?? b.AprobadoEspecial ?? false;
  
  // Los no aprobados (pendientes) van primero
  if (aAprobado !== bAprobado) {
    return aAprobado ? 1 : -1; // false (no aprobado) va antes que true (aprobado)
  }
  
  // Segundo criterio: estado de tienda (abiertas primero)
  const av = a.tiendaCerrada === false ? 0
           : a.tiendaCerrada === true  ? 1
           : 2; // undefined / null / otros => al final

  const bv = b.tiendaCerrada === false ? 0
           : b.tiendaCerrada === true  ? 1
           : 2;

  return av - bv;
});
  }, [especiales, searchTerm, filterTienda, filterUnidad, filterAprobado, filterTiendasCerradas, filterTiendasAbiertas, filterConComentarios, comentariosPorFila, comentariosProveedorMap, comentariosAtlanteMap]);

  const handleSelectTienda = (nombre) => {
    setFilterTienda((prev) =>
      prev.includes(nombre)
        ? prev.filter((t) => t !== nombre)
        : [...prev, nombre]
    );
  };
  const handleSelectUnidad = (unidad) => {
    setFilterUnidad((prev) =>
      prev.includes(unidad)
        ? prev.filter((u) => u !== unidad)
        : [...prev, unidad]
    );
  };
  const handleSelectAprobado = (estado) => {
    setFilterAprobado((prev) =>
      prev.includes(estado)
        ? prev.filter((a) => a !== estado)
        : [...prev, estado]
    );
  };
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const handleAcceptFilters = () => {
    closeModal();
    setCurrentPage(1); // Resetear a página 1 cuando se apliquen filtros
  };
  const handleCleanFilter = () => {
    setFilterTienda([]);
    setFilterUnidad([]);
    setFilterAprobado([]);
    setFilterTiendasCerradas(false);
    setFilterTiendasAbiertas(false);
    setFilterConComentarios(false);
    setCurrentPage(1); // Resetear a página 1 cuando se limpien filtros
  };

   const handleTiendaSelect = (opt) => {
    if (!opt) {
      setSelectedTienda(null);
      return;
    }
    setSelectedTienda(opt);
  };

 const handleSelectTiendasCerradas = () => {
        if(filterTiendasCerradas){
            setFilterTiendasCerradas(false)
        } else {
            if(filterTiendasAbiertas){
                setFilterTiendasAbiertas(false)
            }
            setFilterTiendasCerradas(true)
        }
    };

    const handleSelectTiendasAbiertas = () => {
        if(filterTiendasAbiertas){
            setFilterTiendasAbiertas(false)
        } else {
            if(filterTiendasCerradas){
                setFilterTiendasCerradas(false)
            }
            setFilterTiendasAbiertas(true)
        }
    };

    const handleSelectConComentarios = () => {
        setFilterConComentarios(!filterConComentarios);
    };

  return (
    <section className="dashboard-usuarios">
      <div className="dashboard-usuarios__content__table-header">
        <InputSearch
          context="tableSearch"
          placeholder="Buscar..."
          onSearch={handleSearch}
        />
        {/* Selector de proveedor */}
        <div style={{ minWidth: 260, marginLeft: 16 }}>
          <InputDropdown
            label=""
            value={selectedProveedor ? selectedProveedor.codEmpresa : ""}
            onSelect={(e) => {
              const proveedor = proveedores.find(
                (p) => p.codEmpresa === e.value
              );
              setSelectedProveedor(proveedor || null);
              // fetchEspeciales se llamará automáticamente por el useEffect
            }}
            options={proveedores.map((proveedor) => ({
              value: proveedor.codEmpresa,
              label: proveedor.nombre,
            }))}
            placeholder="Selecciona un proveedor"
          />
        </div>
        <div style={{ width: "1024px" }}>
                  <InputDropdown
                    options={tiendasOptions}
                    onSelect={handleTiendaSelect}
                    placeholder="Seleccionar tienda (por defecto: todas)"
                    showLabel={false}
                    hasSearch={true}
                    value={selectedTienda}
                  />
                </div>
        <Button label="Filtros" onClick={openModal} icon={<FiFilter />} />
        <Button
          label="Eliminar"
          variant="danger"
          onClick={handleDeleteSelectedEspeciales}
          disabled={selectedEspeciales.length === 0}
        />
        <Button
          label="Exportar"
          variant="outline"
          icon={<BiExport />}
          onClick={handleExportExcel}
          disabled={selectedEspeciales.length === 0}
        />
      </div>
      <TableEditable
        data={filteredEspeciales}
        columns={columns}
        noResultsMessage={
          loading ? "Cargando..." : "No se han encontrado registros."
        }
        setData={setEspeciales}
        rowKey="idDetalle"
        notificationRef={notificationRef}
        showHeaderCheckbox={true}
        selectedRows={selectedEspeciales}
        onRowSelect={setSelectedEspeciales}
        currentPage={currentPage}
        onPageChange={setCurrentPage}
        resetPaginationOnDataChange={false}
        onEditCell={(row, key, value) => {
          if (key === "comentariosProveedor")
            handleEditComentarioProveedor(row, value);
          if (key === "comentariosAtlante")
            handleEditComentarioAtlante(row, value);
        }}
        rowClassName={(row) => {
          const isApproved =
            row?.aprobadoEspecial !== undefined
              ? row.aprobadoEspecial
              : row?.AprobadoEspecial;
          return isApproved ? "row-approved" : "";
        }}
      />
      <Notification ref={notificationRef} />
      {isDeleteConfirmOpen && (
        <Popup
          type="alert"
          alertType="warning"
          titleMessage="Confirmar eliminación"
          alertMessage={`¿Estás seguro de que deseas eliminar ${deleteIds.length} mueble${
            deleteIds.length > 1 ? "s" : ""
          } seleccionado${deleteIds.length > 1 ? "s" : ""}?`}
          onConfirm={confirmDeleteSelectedEspeciales}
          onClose={() => setIsDeleteConfirmOpen(false)}
          confirmLabel="Eliminar"
          cancelLabel="Cancelar"
        />
      )}
      {/* Modal de filtros */}
      <Modal
        title="Filtros"
        isOpen={isModalOpen}
        onClose={closeModal}
        onAccept={handleAcceptFilters}
        outlineButtonLabel="Limpiar"
        primaryButtonLabel={`Ver resultados (${filteredEspeciales.length})`}
        onCancel={handleCleanFilter}
      >
        <div>
          <Accordion title="Tienda">
            <ul className="section-header__modal__section__content">
              {tiendas.map((nombre, idx) => (
                <Tag
                  key={idx}
                  label={nombre}
                  isSelected={filterTienda.includes(nombre)}
                  onSelect={handleSelectTienda}
                />
              ))}
            </ul>
          </Accordion>
        </div>
        <Accordion title="Estado tienda">
          <Tag
            key="estadoLabel"
            label="Tiendas cerradas (C)"
            isSelected={filterTiendasCerradas}
            onSelect={handleSelectTiendasCerradas}
          />
          <Tag
            key="estadoLabel"
            label="Tiendas abiertas"
            isSelected={filterTiendasAbiertas}
            onSelect={handleSelectTiendasAbiertas}
          />
        </Accordion>
        <div className="section-header__modal__section">
          <Accordion title="Unidad">
            <ul className="section-header__modal__section__content">
              {unidades.map((unidad, idx) => (
                <Tag
                  key={idx}
                  label={unidad}
                  isSelected={filterUnidad.includes(unidad)}
                  onSelect={handleSelectUnidad}
                />
              ))}
            </ul>
          </Accordion>
        </div>
        <div className="section-header__modal__section">
          <Accordion title="Aprobado">
            <ul className="section-header__modal__section__content">
              {aprobados.map((estado, idx) => (
                <Tag
                  key={idx}
                  label={estado}
                  isSelected={filterAprobado.includes(estado)}
                  onSelect={handleSelectAprobado}
                />
              ))}
            </ul>
          </Accordion>
        </div>
        <div className="section-header__modal__section">
          <Accordion title="Comentarios">
            <Tag
              key="conComentarios"
              label="Solo muebles con comentarios"
              isSelected={filterConComentarios}
              onSelect={handleSelectConComentarios}
            />
          </Accordion>
        </div>
      </Modal>
      {/* Modal de comentarios */}
      <Modal
        title={`Comentarios de ${comentarioModalRow?.referencia || ""}`}
        isOpen={isComentariosModalOpen}
        onClose={handleCloseComentariosModal}
        onCancel={handleCloseComentariosModal}
        hideFooter={true}
        className="modal--centered"
      >
        <div className="detalle-mueble__info__comments">
          <div className="detalle-mueble__info__comments__comments-list">
            {comentarioModalRow &&
            (comentariosPorFila[comentarioModalRow.idDetalle] || []).length >
              0 ? (
              <>
                {(comentariosPorFila[comentarioModalRow.idDetalle] || []).map(
                  (com, idx) => (
                    <div
                      key={com.codComentario}
                      className="detalle-mueble__info__comments__comments-list__item"
                    >
                      <div className="detalle-mueble__info__comments__comments-list__item__info">
                        <div className="detalle-mueble__info__comments__comments-list__item__author">
                          <div className="avatar">
                            <div className="avatar__inner">
                              {com.nombreUsuario.charAt(0).toUpperCase()}
                            </div>
                          </div>
                          <p>{com.nombreUsuario}</p>
                          {com.fecha && (
                            <span style={{ marginLeft: 8, color: "#888" }}>
                              ({com.fecha})
                            </span>
                          )}
                        </div>
                      </div>
                      <p className="detalle-mueble__info__comments__comments-list__item__comment">
                        {com.comentario || (
                          <span style={{ color: "#aaa" }}>Sin comentario</span>
                        )}
                      </p>
                      {com.rutasArchivos && com.rutasArchivos.length > 0 && (
                        <FileList files={com.rutasArchivos} filesVisible={3} />
                      )}
                    </div>
                  )
                )}
              </>
            ) : (
              <p
                className="detalle-mueble__info__comments__comments-list__item__comment"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "12px 0",
                  fontWeight: "700",
                }}
              >
                Todavía no hay comentarios en este mueble.
              </p>
            )}
          </div>
          {/* Formulario para agregar comentario */}
          <div className="detalle-mueble__info__comments__add-comment">
            <InputTextfield
              label="Escribe tu comentario"
              value={comentarioModalInput}
              onChange={(e) => setComentarioModalInput(e.target.value)}
              onPaste={handlePasteImage}
              placeholder="Escribe aquí tu comentario..."
            />
            <Input
              type="file"
              label="Archivo adjunto"
              name="archivoAdjunto"
              placeholder={comentarioModalInputFileText}
              multipleFiles={true}
              onChange={handleComentarioModalFiles}
            />
            {comentarioModalFiles.length > 0 && (
              <FileList
                files={comentarioModalFiles}
                handleDelete={(file) =>
                  setComentarioModalFiles((prev) =>
                    prev.filter((f) => f.name !== file.name)
                  )
                }
              />
            )}
            <Button
              label="Enviar comentario"
              variant="filled"
              onClick={handleEnviarComentarioModal}
            />
          </div>
        </div>
      </Modal>
    </section>
  );
}
